<template>
  <div class="page">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>今日积分消耗</span>
        <el-button type="text" @click="$router.push('/admin/dashboard')">返回仪表盘</el-button>
      </div>
      <el-form :inline="true" size="small">
        <el-form-item label="日期">
          <el-date-picker v-model="date" type="date" value-format="yyyy-MM-dd" :clearable="false" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="reload">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="loading" :data="list" border stripe>
        <el-table-column prop="createdAt" label="时间" width="170">
          <template slot-scope="{ row }">{{ formatTime(row.createdAt) }}</template>
        </el-table-column>
        <el-table-column prop="nickname" label="用户" min-width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.nickname || row.userId || '-' }}</template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="130">
          <template slot-scope="{ row }">{{ row.phone || '-' }}</template>
        </el-table-column>
        <el-table-column prop="credits" label="消耗积分" width="110" align="right" />
        <el-table-column prop="businessType" label="业务类型" width="140" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ formatBusinessType(row.businessType) }}</template>
        </el-table-column>
        <el-table-column prop="description" label="说明" min-width="180" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ formatOpsDescription(row.description) }}</template>
        </el-table-column>
        <el-table-column prop="relatedTaskId" label="任务/单号" min-width="160" show-overflow-tooltip />
      </el-table>
      <div class="pager-wrap">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page="page"
          @current-change="onPageChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { getOpsCredits } from '@/api/admin'
import { todayShanghai, formatDateTime, formatBusinessType, formatOpsDescription } from './opsFormat'

export default {
  name: 'OpsCredits',
  data() {
    return {
      loading: false,
      date: todayShanghai(),
      list: [],
      total: 0,
      page: 1,
      pageSize: 20
    }
  },
  created() {
    this.load()
  },
  methods: {
    formatTime: formatDateTime,
    formatBusinessType,
    formatOpsDescription,
    onPageChange(page) {
      this.page = page
      this.load()
    },
    reload() {
      this.page = 1
      this.load()
    },
    async load() {
      this.loading = true
      try {
        const result = await getOpsCredits({ date: this.date, page: this.page, size: this.pageSize })
        this.list = (result && result.list) || []
        this.total = (result && result.total) || 0
      } catch (e) {
        this.list = []
        this.total = 0
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pager-wrap {
  margin-top: 16px;
  text-align: right;
}
</style>
